import * as React from 'react';
import { Layout, LayoutProps } from 'react-admin';
import AppBar from '../AppBar/AppBar';
import Menu from '../Menu/Menu';

const LayoutPage: React.FC = (props: LayoutProps) => (
  <Layout {...props} appBar={AppBar} menu={Menu} />
);

export default LayoutPage;
